import api from "./api";

export const customerSegmentsService = {
    async list({ includeInactive = false } = {}) {
        const { data } = await api.get("/customer-segments", {
            params: includeInactive ? { include_inactive: true } : {},
        });
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/customer-segments", payload);
        return data;
    },
    async patch(id, payload) {
        const { data } = await api.patch(`/customer-segments/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/customer-segments/${id}`);
    },
};
